export default __webpack_public_path__ + "2600960c4d1a433ff0e0bb6fd545807c.png";